import api from "./api";
import UtilsUrl from "../utils/UtilsUrl";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";
class SellingService {
  getPayementsFromBorderau(idUser, idBorderau) {
    return api.get(
      "/sales/payement/getPayementsFromBorderau/" + idUser + "/" + idBorderau
    );
  }
  setSellingPrice(model) {
    return api.post(UtilsUrl.sellingProductURL() + "/setSellingPrice", model);
  }

  getAllDevisNotArchived(idUser) {
    return api.get(
      UtilsUrl.sellingDocumentURL() + "/getAllDevisNotArchived/" + idUser
    );
  }
  getAllDevisNotArchivedByWarehouseId(idUser, idWarehouse) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getAllDevisNotArchivedByWarehouseId/" +
        idUser +
        "/" +
        idWarehouse
    );
  }
  getAllProductsOnSale(idUser, onSale, idWarehouse) {
    return api.get(
      UtilsUrl.sellingProductSalesURL() +
        "/getAllProductsOnSale/" +
        idUser +
        "/" +
        onSale +
        "/" +
        idWarehouse
    );
  }
  getAllProductsOnSaleForCreatingPack(idUser, onSale, idWarehouse) {
    return api.get(
      UtilsUrl.sellingProductSalesURL() +
        "/getAllProductsOnSaleForCreatingPack/" +
        idUser +
        "/" +
        onSale +
        "/" +
        idWarehouse
    );
  }
  getAllProductsOnSaleForCreatingPackComposition(idUser, onSale, idWarehouse) {
    return api.get(
      UtilsUrl.sellingProductSalesURL() +
        "/getAllProductsOnSaleForCreatingPackComposition/" +
        idUser +
        "/" +
        onSale +
        "/" +
        idWarehouse
    );
  }
  getAllProductsOnSaleV2(idUser, onSale, idWarehouse) {
    return api.get(
      UtilsUrl.sellingProductSalesURL() +
        "/getAllProductsOnSaleV2/" +
        idUser +
        "/" +
        onSale +
        "/" +
        idWarehouse
    );
  }

  addDevis(devisModel) {
    return api.post(UtilsUrl.sellingDocumentURL() + "/addDevis", devisModel);
  }
  addBC(bdcModel) {
    return api.post(UtilsUrl.sellingDocumentURL() + "/addBDC", bdcModel);
  }
  addFacture(factureModel) {
    return api.post(
      UtilsUrl.sellingDocumentURL() + "/addFacture",
      factureModel
    );
  }
  addFactureAvr(factureModel) {
    return api.post(
      UtilsUrl.sellingDocumentURL() + "/addFactureAvr",
      factureModel
    );
  }
  updateFactureProductQteByFacture(idUser, ref, idProduct, qte) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        `/updateFactureProductQteByFacture/${idUser}/${ref}/${idProduct}/${qte}`
    );
  }
  removeProdutToFactureByFacture(idUser, ref, idProduct) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        `/removeProdutToFactureByFacture/${idUser}/${ref}/${idProduct}`
    );
  }
  updateFactureProductPriceByFacture(idUser, ref, idProduct, pricehtc,promo,price) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        `/updateFactureProductPriceByFacture/${idUser}/${ref}/${idProduct}/${pricehtc}/${promo}/${price}`
    );
  }
  addProdutToFactureByFactureByBarCode(idUser, ref, barcode, quantity,pricehtc,promo,price) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        `/addProdutToFactureByFactureByBarCode/${idUser}/${ref}/${barcode}/${quantity}/${pricehtc}/${promo}/${price}`
    );
  }


  updateFactureClient(idUser, ref, idClient) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        `/updateFactureClient/${idUser}/${ref}/${idClient}`
    );
  }
  getDevisSellOfLastMonth(idUser, isDeleted) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getDevisOfLastMonth/" +
        idUser +
        "/" +
        isDeleted
    );
  }
  getDevisByRef(quotationReference, idUser) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getDevisByRef/" +
        idUser +
        "/" +
        quotationReference
    );
  }
  getDevisByFilters(idUser, idClient, state, datedebut, dateFin) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getDevisByFilters/" +
        idUser +
        "/" +
        datedebut +
        "/" +
        dateFin +
        "/" +
        state +
        "/" +
        idClient
    );
  }
  //Bon commande
  getBDCByFilters(idUser, idClient, state, datedebut, dateFin) {
    // let currentUser = currentUserId();
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getBDCByFilters/" +
        idUser +
        "/" +
        datedebut +
        "/" +
        dateFin +
        "/" +
        state +
        "/" +
        idClient
    );
  }

  getBDCByFiltersOptimized(idUser, idClient, state, datedebut, dateFin) {
    // let currentUser = currentUserId();
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getBDCByFiltersOptimized/" +
        idUser +
        "/" +
        datedebut +
        "/" +
        dateFin +
        "/" +
        state +
        "/" +
        idClient
    );
  }
  // same parameters as getBDCByFiltersOptimized, dates applied on the estimated delivery date
  getBDCByDeliveryDate(idUser, idClient, state, datedebut, dateFin) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getBDCByDeliveryDate/" +
        idUser +
        "/" +
        datedebut +
        "/" +
        dateFin +
        "/" +
        state +
        "/" +
        idClient
    );
  }
  getBDCSellOfLastMonth(idUser, isDeleted) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getBDCOfLastMonth/" +
        idUser +
        "/" +
        isDeleted
    );
  }

  getBDCSellOfLastMonthOptimized(idUser, isDeleted) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getBDCOfLastMonthOptimized/" +
        idUser +
        "/" +
        isDeleted
    );
  }
  getAllDevisNotRelatedToBDCeNotArchived(idUser, idWarehouse) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getAllDevisNotRelatedToBDCeNotArchived/" +
        idUser +
        "/" +
        idWarehouse
    );
  }
  getAllBDCNotArchived(idUser, idWarehouse) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getAllBDCNotArchived/" +
        idUser +
        "/" +
        idWarehouse
    );
  }

  getAllRefNotLiveredBDCNotArchived(idUser, state1, state2) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getAllRefNotLiveredBDCNotArchived/" +
        idUser +
        "/" +
        state1 +
        "/" +
        state2
    );
  }
  getBDCByRef(quotationReference, idUser) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getBDCByRef/" +
        idUser +
        "/" +
        quotationReference
    );
  }

  //Facture
  getAllFactureNotArchived(idUser, idWarehouse) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getAllFactureNotArchived/" +
        idUser +
        "/" +
        idWarehouse
    );
  }

  getAllBDCNotRelatedToFactureAndNotArchived(idUser, idWarehouse) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getAllBDCNotRelatedToFactureAndNotArchived/" +
        idUser +
        "/" +
        idWarehouse
    );
  }
  getFactureOfLastMonth(idUser, isDeleted) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getFactureOfLastMonth/" +
        idUser +
        "/" +
        isDeleted
    );
  }

  getFactureOfLastMonthOptimized(idUser, isDeleted) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getFactureOfLastMonthOptimized/" +
        idUser +
        "/" +
        isDeleted
    );
  }
  getFactureByFilters(idUser, idSupplier, state, datedebut, dateFin) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getFactureByFilters/" +
        idUser +
        "/" +
        datedebut +
        "/" +
        dateFin +
        "/" +
        state +
        "/" +
        idSupplier
    );
  }

  getFactureByFiltersOptimized(idUser, idSupplier, state, datedebut, dateFin) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getFactureByFiltersOptimized/" +
        idUser +
        "/" +
        datedebut +
        "/" +
        dateFin +
        "/" +
        state +
        "/" +
        idSupplier
    );
  }

  getCaByClient(idUser, idSupplier, state, datedebut, dateFin) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getCaByClient/" +
        idUser +
        "/" +
        datedebut +
        "/" +
        dateFin +
        "/" +
        state +
        "/" +
        idSupplier
    );
  }

  getFactureByRef(quotationReference, idUser) {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/getFactureByRef/" +
        idUser +
        "/" +
        quotationReference
    );
  }
  generateDevis(idUser, ref) {
    return api.get(
      UtilsUrl.sellingFileURL() + "/generateDevis/" + idUser + "/" + ref
    );
  }
  // language ("fr" / "en"): the file is generated in that language, which becomes the one of the order
  generateBDC(idUser, ref, language) {
    return api.get(
      UtilsUrl.sellingFileURL() + "/generateBDC/" + idUser + "/" + ref,
      language ? { params: { language } } : undefined
    );
  }
  validateDevis(idUser, idDevis) {
    return api.get(
      UtilsUrl.sellingDocumentURL() + "/addCommande/" + idUser + "/" + idDevis
    );
  }
  generateFacture(idUser, ref) {
    return api.get(
      UtilsUrl.sellingFileURL() + "/generateFacture/" + idUser + "/" + ref
    );
  }

   generateFactureXML(idUser, ref) {
    return api.get(
      "/sales/xml/genrateFactureXML/" + idUser + "/" + ref
    );
  }

  uploadFile(url, picture) {
    return api.post(UtilsUrl.sellingFileURL() + url, picture, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  updateBDCPathFile(idUser, refDevis, path) {
    let updateADocumentPathFilePathModel = {
      idUser: idUser,
      refDocument: refDevis,
      path: path,
    };
    console.log("updateBDCPathFile", updateADocumentPathFilePathModel);

    return api.put(
      "/sales/document/updateBDCPathFile/",
      updateADocumentPathFilePathModel
    );
  }
  //recieve commande
  getSalesByRefPOOrByRefFacture(reference, idUser) {
    return api.get(
      UtilsUrl.sellingOrderURL() +
        "/getSalesByRefPOOrByRefFacture/" +
        reference +
        "/" +
        idUser
    );
  }
  getSalesByRefCByRefBDC(reference, idUser) {
    return api.get(
      UtilsUrl.sellingOrderURL() +
        "/getSalesByRefCByRefBDC/" +
        reference +
        "/" +
        idUser
    );
  }
  getSalesByRefCByRefBDCForReturn(reference, idUser) {
    return api.get(
      UtilsUrl.sellingOrderURL() +
        "/getSalesByRefCByRefBDCForReturn/" +
        reference +
        "/" +
        idUser
    );
  }

  validateSalesOrderToRealWarehouse(model) {
    return api.post(
      UtilsUrl.sellingOrderURL() + "/validateSalesOrderToRealWarehouse",
      model
    );
  }
  getFacturesNotPayedByGroupe(idUser, idGroupe, year, month) {
    return api.get(
      UtilsUrl.sellingOrderURL() +
        `/getFacturesNotPayedByGroupe/${idUser}/${idGroupe}/${year}/${month}`
    );
  }
  returnSalesOrderToRealWarehouse(model) {
    return api.post(
      UtilsUrl.sellingOrderURL() + "/returnSalesOrderToRealWarehouse",
      model
    );
  }

  getProductSalesCurrentQte(idProduct, idUser) {
    return api.get(
      UtilsUrl.sellingOrderURL() +
        "/getProductSalesCurrentQte/" +
        idProduct +
        "/" +
        idUser
    );
  }
  getProductTransactionHistoryByBCSell(idBC, idUser) {
    return api.get(
      UtilsUrl.sellingOrderURL() +
        "/getProductTransactionHistoryByBCSell/" +
        idBC +
        "/" +
        idUser
    );
  }

  verifieBCSellExistanceByReference = (idUser, refBC) => {
    return api.get(
      UtilsUrl.sellingDocumentURL() +
        "/verifieBCSellExistanceByReference/" +
        idUser +
        "/" +
        refBC
    );
  };

  getAllDocumentsSalesByFilterForPayementTask = (
    isPayedForBackend,
    idSupplier,
    month,
    year,
    documentType
  ) => {
    let currentUser = currentUserId();

    let idSupllierForBackend = "any";
    let monthForBackend = "any";
    let yearForBackend = "any";
    let isPayed;

    if (idSupplier === "any") {
      idSupllierForBackend = 0;
    } else {
      idSupllierForBackend = parseInt(idSupplier);
    }
    if (isPayedForBackend === "any") {
      isPayed = -1;
    } else {
      isPayed = parseInt(isPayedForBackend);
    }

    if (month !== "00") {
      monthForBackend = month;
    }

    if (year !== "Tous" && year !== "00") {
      yearForBackend = year;
    }

    return api.get(
      `/sales/document/getAllDocumentsByFilterForPayementTask/${currentUser}/${isPayed}/${idSupllierForBackend}/${monthForBackend}/${yearForBackend}/${documentType}`
    );
  };
  getDocumentForPayementTask(idDocument, isFactureOrBDC) {
    let currentUser = currentUserId();
    return api.get(
      `/sales/document/getDocumentForPayementTask/${currentUser}/${parseInt(
        idDocument
      )}/${isFactureOrBDC}`
    );
  }
  updateBDCSale(data) {
    return api.put(`/sales/document/updateBDCSale`, data);
  }
  AvoirFacture(currentUser, idFacture) {
    return api.get(
      `/sales/document/createAvrFactureFromFacture/${currentUser}/${idFacture}`
    );
  }
  getFacturePayementInformation(idFacture, typeDocument) {
    let currentUser = currentUserId();
    return api.get(
      `/sales/payement/getFacturePayementInformation/${currentUser}/${parseInt(
        idFacture
      )}/${typeDocument}`
    );
  }

  deleteAndRestoreDevis(refDevis, isDeleted) {
    let currentUser = currentUserId();
    return api.put(
      `/sales/document/deleteAndRestoreDevis/${currentUser}/${refDevis}/${isDeleted}`
    );
  }

  deleteAndRestoreBDC(refDevis, isDeleted) {
    let currentUser = currentUserId();
    return api.put(
      `/sales/document/deleteAndRestoreBDC/${currentUser}/${refDevis}/${isDeleted}`
    );
  }

  generateRetenuSource(idUser, percentRetenu, idDocument) {
    return api.get(
      "/sales/payement/generateRetenu/" +
        idUser +
        "/" +
        percentRetenu +
        "/" +
        idDocument
    );
  }

  generateRetenuSourceV2(idUser, percentRetenu, amountRetenu, idDocument) {
    return api.get(
      "/sales/payement/generateRetenuV2/" +
        idUser +
        "/" +
        percentRetenu +
        "/" +
        amountRetenu +
        "/" +
        idDocument
    );
  }

  saveRetenuSourceVenteWithFile(idUser, retenuPercent, idDocument, path) {
    return api.get(
      "/sales/payement/generateRetenuVenteWithFile/" +
        idUser +
        "/" +
        idDocument +
        "/" +
        retenuPercent +
        "/" +
        path
    );
  }

  saveRetenuSourceVenteWithFileV2ByFactureSelected(retenuModel) {
    return api.post("/sales/payement/retenuWallet", retenuModel);
  }
  saveRetenuSourceVenteWithFileV2(retenuModel) {
    return api.post(
      "/sales/payement/generateRetenuVenteWithFileV2",
      retenuModel
    );
  }
  getFactureRetenueExistance(retenuExistanceModel) {
    retenuExistanceModel.idUser = currentUserId();

    return api.post(
      "/sales/payement/getFacturesRetenueExistance",
      retenuExistanceModel
    );
  }
  payFactureOrBDC(payFactureOrAvance) {
    payFactureOrAvance.idUser = currentUserId();

    return api.post("/sales/payement/payFactureOrBDC", payFactureOrAvance);
  }

  transfertAccount(payFactureOrAvance) {
    return api.post("/sales/payement/transfertAccount", payFactureOrAvance);
  }

  getStockForProduct(idUser, idProduct, idWarehouse) {
    return api.get(
      `/sales/productsales/getProductStockInfo/${idUser}/${idProduct}/${idWarehouse}`
    );
  }
  getProductsPricesByWarehouse(idUser, idWarehouse) {
    return api.get(
      `/sales/productsales/getProductsPricesByWarehouse/${idUser}/${idWarehouse}`
    );
  }
  // params: { months, minQuantity, idWarehouse, q, sortBy, sortDirection, page, size }
  // (idWarehouse omitted = all warehouses)
  analyseStockVente(idUser, params) {
    return api.get(`/sales/productsales/analyseStockVente/${idUser}`, { params });
  }

  // params: { page, size, sortBy, sortDirection, q }
  getProductsPricesByWarehousePaged(idUser, idWarehouse, params = {}) {
    return api.get(
      `/sales/productsales/getProductsPricesByWarehousePaged/${idUser}/${idWarehouse}`,
      { params }
    );
  }

  createFactureFromOperation(idUser, refOperation, idWarehouse) {
    return api.post(
      `/sales/document/createFactureFromOperation/${idUser}/${idWarehouse}/${refOperation}`
    );
  }
  createFactureAvrFromOperation(idUser, refOperation, idWarehouse) {
    return api.post(
      `/sales/document/createAvrFactureFromOperation/${idUser}/${idWarehouse}/${refOperation}`
    );
  }
  getListAvancePayementBDC(idDocument) {
    let currentUser = currentUserId();
    return api.get(
      `/sales/payement/getListAvancePayementBDC/${currentUser}/${parseInt(
        idDocument
      )}`
    );
  }
  getRealProductStockInfo(idUser, idProduct, idWarehouse) {
    return api.get(
      `/sales/productsales/getRealProductStockInfo/${idUser}/${idProduct}/${idWarehouse}`
    );
  }

  retenuSimulator(idUser, percentRetenu, idDocument) {
    return api.get(
      `/sales/payement/retenuSimulator/${idUser}/${percentRetenu}/${idDocument}`
    );
  }
  retenuSimulatorByFacture(idUser, percentRetenu, montant) {
    return api.get(
      `/sales/payement/retenuSimulatorWallet/${idUser}/${percentRetenu}/${montant}`
    );
  }
  generateBordereau(bordereauModel) {
    return api.post("/sales/payement/generateBordereau", bordereauModel);
  }
  getListBordereauByUserAndDates(idUser, dateDebut, dateFin) {
    return api.get(
      "/sales/payement/getListBordereau/" +
        idUser +
        "/" +
        dateDebut +
        "/" +
        dateFin
    );
  }
  finaliserPayement(typeDocument, idDocument) {
    console.log("idDocument", idDocument);
    return api.get(
      "/sales/payement/finaliserPayement/" + idDocument + "/" + typeDocument
    );
  }
  getAllProductsInAllBonCommandeSortie(
    idZone,
    idUser,
    idTransporteur,
    dateDebut,
    dateFin
  ) {
    return api.get(
      UtilsUrl.sellingOrderURL() +
        "/getAllProductsInAllBonCommandeSortie/" +
        idZone +
        "/" +
        idUser +
        "/" +
        idTransporteur +
        `?dateDebutToFilter=${dateDebut}&dateFinToFilter=${dateFin}`
    );
  }
  getProductsPlanningBySociete(
    idZone,
    idUser,
    idTransporteur,
    idCommericial,
    dateDebut,
    dateFin
  ) {
    return api.get(
      UtilsUrl.sellingOrderURL() +
        "/getProductsPlanningBySociete/" +
        idZone +
        "/" +
        idUser +
        "/" +
        idTransporteur +
        "/" +
        idCommericial +
        `?dateDebutToFilter=${dateDebut}&dateFinToFilter=${dateFin}`
    );
  }

    getProductsPlanningBySocieteAllZones(
    idUser,
    idTransporteur,
    idCommericial,
    dateDebut,
    dateFin
  ) {
    return api.get(
      UtilsUrl.sellingOrderURL() +
        "/getProductsPlanningBySocieteAllZones/" +
        idUser +
        "/" +
        idTransporteur +
        "/" +
        idCommericial +
        `?dateDebutToFilter=${dateDebut}&dateFinToFilter=${dateFin}`
    );
  }
  payFactureByWalletAndGroupe(userId, data) {
    return api.put(
      "/sales/payement/payFactureByWalletAndGroupe/" + userId,
      data
    );
  }
  updateBC(model) {
    return api.put(
      UtilsUrl.sellingOrderURL() + "/updateDateAndRefBdSortie",
      model
    );
  }
  getProductsTransactionsAndTransferts(idUser, idProduct) {
    return api.get(
      UtilsUrl.sellingOrderURL() +
        `/getProductsTransactionsAndTransferts/${idUser}/${idProduct}`
    );
  }
  getProductsTransactionsAndTransfertsByWarehouseAndDate(
    idUser,
    idProduct,
    idWarehouse,
    dateDebutToFilter,
    dateFinToFilter
  ) {
    return api.get(
      UtilsUrl.sellingOrderURL() +
        `/getProductsTransactionsAndTransfertsByWarehouseAndDate/${idUser}/${idProduct}/${idWarehouse}?dateDebutToFilter=${dateDebutToFilter}&dateFinToFilter=${dateFinToFilter}`
    );
  }
  getProductsTransactionsAndTransfertsByWarehouse(
    idUser,
    idProduct,
    idWarehouse
  ) {
    return api.get(
      UtilsUrl.sellingOrderURL() +
        `/getProductsTransactionsAndTransfertsByWarehouse/${idUser}/${idProduct}/${idWarehouse}`
    );
  }
  // consolidated products to deliver, period on the BDC delivery date (yyyy-MM-dd)
  getProductsToDeliver(idUser, dateDebut, dateFin, includeFinished = false) {
    return api.get(
      UtilsUrl.sellingOrderURL() +
        "/getProductsToDeliver/" +
        idUser +
        `?dateDebut=${dateDebut}&dateFin=${dateFin}&includeFinished=${includeFinished}`
    );
  }
  updateProductSaleNote(idUser, idProductSale, note) {
    return api.put(
      UtilsUrl.sellingDocumentURL() +
        `/updateProductSaleNote/${idUser}/${idProductSale}`,
      note || "",
      { headers: { "Content-Type": "text/plain" } }
    );
  }
  getProductsInBonCommandesSalesByDate(
    idUser,
    dateDebutToFilter,
    dateFinToFilter
  ) {
    return api.get(
      UtilsUrl.sellingOrderURL() +
        "/getProductsInBonCommandesSalesByDate/" +
        idUser +
        `?dateDebutToFilter=${dateDebutToFilter}&dateFinToFilter=${dateFinToFilter}`
    );
  }
  updateBonCommandeSaleCreationDate(idUser, reference, creationDate) {
    return api.put(
      UtilsUrl.sellingOrderURL() +
        `/BDCSale/updateBonCommandeSaleCreationDate/${idUser}/${reference}/${creationDate}`
    );
  }
  getFactureClientByGroup(data) {
    return api.post(
      `${UtilsUrl.sellingOrderURL()}/getFactureClientByGroup`,
      data
    );
  }
  addRefReceptionToBonCommandeSale(data) {
    return api.put(
      `${UtilsUrl.sellingOrderURL()}/BDC/addRefReceptionToBonCommandeSale`,
      data
    );
  }
  recapBonCommandeSale(idUser, idZone, dateDebutToFilter, dateFinToFilter) {
    return api.get(
      `${UtilsUrl.sellingOrderURL()}/BDCSale/recapBonCommandeSale/${idUser}/${idZone}?dateDebutToFilter=${dateDebutToFilter}&dateFinToFilter=${dateFinToFilter}`
    );
  }

  recapBonCommandeSaleAllZones(idUser, dateDebutToFilter, dateFinToFilter) {
    return api.get(
      `${UtilsUrl.sellingOrderURL()}/BDCSale/recapBonCommandeSaleAllZones/${idUser}?dateDebutToFilter=${dateDebutToFilter}&dateFinToFilter=${dateFinToFilter}`
    );
  }
  changeVarReturnToSocieteInBonCommandesSale(idUser, idBDCSale, variable) {
    return api.put(
      `${UtilsUrl.sellingOrderURL()}/BDCSale/changeVarReturnToSocieteInBonCommandesSale/${idUser}/${idBDCSale}?variable=${variable}`
    );
  }
  payementsTransferts(idUser, dateDebut, dateFin) {
    return api.get(
      "/sales/payement/payementsTransferts/getPayementsTransferts/" +
        idUser +
        `?dateDebutToFilter=${dateDebut}&dateFinToFilter=${dateFin}`
    );
  }
  getPayementInfoByPayementTransfert(idUser, idPayementTransfert) {
    return api.get(
      "/sales/payement/payementsTransferts/getPayementInfoByPayementTransfert/" +
        idUser +
        `/` +
        idPayementTransfert
    );
  }
  getListPayementsInformationsByBankAccount(
    idUser,
    idBankAccount,
    dd,
    df,
    type
  ) {
    return api.get(
      "/sales/payement/getListPayementsInformationsByBankAccount/" +
        idUser +
        "/" +
        idBankAccount +
        "/" +
        dd +
        "/" +
        df +
        "/" +
        type
    );
  }
  getWalletByGroupe(idUser, idGroupe) {
    return api.get(
      `/sales/tiersAccount/getWalletByGroupe/${idUser}/${idGroupe}`
    );
  }

  updateTiersAccountSolde(model) {
    return api.post("/sales/payement/updateTiersAccountSolde", model);
  }
}

export default new SellingService();
